import { UserListData } from "routes/analysis/types/analysis";

export const parseStats = (userList: UserListData) => ({
	userCount: userList.pagination.items,
	userTotal: userList.pagination.totalItems,
	userDialog: userList.data.filter(f => f.type === "A").length,
	userSystem: userList.data.filter(f => f.type === "B").length,
	userCommunication: userList.data.filter(f => f.type === "C").length,
	userService: userList.data.filter(f => f.type === "S").length,
});
